export const MS_PER_DAY = 1000 * 60 * 60 * 24;

/**
 * Whole calendar days from `from` to `to` in the browser's timezone: 0 when both
 * instants fall on the same local date, negative when `to` precedes `from`. Each
 * instant is reduced to its local date and the two are compared as UTC
 * midnights, so a DST transition between them cannot shift the count.
 */
export const calendarDaysBetween = (from: Date, to: Date): number =>
  (Date.UTC(to.getFullYear(), to.getMonth(), to.getDate()) -
    Date.UTC(from.getFullYear(), from.getMonth(), from.getDate())) /
  MS_PER_DAY;
